<fieldset class="bordas" [style]="'width: auto'">
    <div fxLayout="row">
        <mat-toolbar class="titulopartes">Ação Executada</mat-toolbar>
    </div>
    <div>
        <div fxLayout="column" fxFlex="90%">
            <div fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex="50">
                    <input #descricao matInput maxlength="200" name="descricao_{{idRandomico}}"
                           placeholder="Descrição" [(ngModel)]="acaoExecutada.descricao" required>
                    <mat-hint align="end">{{ descricao.value.length }} / 200</mat-hint>
                </mat-form-field>

                <mat-form-field fxFlex="15">
                    <input matInput name="dataInicioAcao_{{idRandomico}}" [matDatepicker]="dataInicioAcao"
                           placeholder="Data Início:"
                           [(ngModel)]="acaoExecutada.dataInicio" (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataInicioAcao"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicioAcao></mat-datepicker>
                </mat-form-field>

                <mat-form-field fxFlex="10">
                    <input matInput #horaInicio="ngModel" mat-hide-icons="calendar" type="time" name="horaInicio_{{idRandomico}}"
                           placeholder="Hora Início:" [(ngModel)]="acaoExecutada.horaInicio">
                </mat-form-field>

                <mat-form-field fxFlex="15">
                    <input matInput name="dataFimAcao_{{idRandomico}}" [matDatepicker]="dataFimAcao" placeholder="Data Fim:"
                           [(ngModel)]="acaoExecutada.dataFim" (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataFimAcao"></mat-datepicker-toggle>
                    <mat-datepicker #dataFimAcao></mat-datepicker>
                </mat-form-field>

                <mat-form-field fxFlex="10">
                    <input matInput mat-hide-icons="calendar" type="time" name="horaFimAcao_{{idRandomico}}"
                           placeholder="Hora Fim:" [(ngModel)]="acaoExecutada.horaFim">
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex="33">
                    <input #descricaoOcorrenciaAcao matInput maxlength="200" name="descricaoOcorrenciaAcao_{{idRandomico}}"
                           placeholder="Ocorrência" [(ngModel)]="acaoExecutada.descricaoOcorrencia">
                    <mat-hint align="end">{{ descricaoOcorrenciaAcao.value.length }} / 200</mat-hint>
                </mat-form-field>

                <mat-form-field fxFlex="33">
                    <input #descricaoMetodologiaAcao matInput maxlength="200" name="descricaoMetodologiaAcao_{{idRandomico}}"
                           placeholder="Metodologia" [(ngModel)]="acaoExecutada.descricaoMetodologia">
                    <mat-hint align="end">{{ descricaoMetodologiaAcao.value.length }} / 200</mat-hint>
                </mat-form-field>

                <mat-form-field fxFlex="33">
                    <input #descricaoAvaliacaoAcao matInput maxlength="200" name="descricaoAvaliacaoAcao_{{idRandomico}}"
                           placeholder="Avaliação" [(ngModel)]="acaoExecutada.descricaoAvaliacao">
                    <mat-hint align="end">{{ descricaoAvaliacaoAcao.value.length }} / 200</mat-hint>
                </mat-form-field>
            </div>


            <div fxLayout="row">
                <mat-form-field fxFlex="20">
                    <input matInput #qtdParticipantes="ngModel"
                           name="qtdParticipantes_{{idRandomico}}"
                           placeholder="Quantidade de Participantes:"
                           [(ngModel)]="acaoExecutada.qtdParticipantes"
                           maxlength="6"
                           pattern="[0-9]+$"
                    >
                </mat-form-field>

                <div ngModelGroup="comboFuncionario_{{idRandomico}}" fxFlex="80">
                    <!-- <combo-funcionario [showDisplayId]="false"
                                       [obrigatorio]="false"
                                       [selecionado]="acaoExecutada.funcionarioResponsavel"
                                       (valorChange)="onValorChangeFuncionario($event)"
                                       [label]="'Funcionário Responsável'">
                    </combo-funcionario> -->
                </div>
            </div>
        </div>

        <div fxLayout="column" fxFlex="10%" fxLayoutAlign="center center">
            <button mat-icon-button *ngIf="perfilAcesso.deleta" (click)="deletar()" style="padding: 0px;">
                <mat-icon>delete_forever</mat-icon>
            </button>
        </div>
    </div>
    <mat-tab-group #tabGroup>
        <mat-tab label="METAS DA AÇÃO EXECUTADA">
            <div ngModelGroup="grupoAcoesMetas" fxLayout="column" fxFlex="100%" style="margin: 2px 0;">
                <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <div *ngFor="let meta of acaoExecutada.metas; let index = index">
                        <!-- <formulario-acoes-executada-metas-turma [meta]="meta"
                                                          [index]="index"
                                                          [metas]="acaoExecutada.metas"
                                                          [perfilAcesso]="perfilAcesso"
                                                          [metasAcao]="metasAcao">
                        </formulario-acoes-executada-metas-turma> -->
                    </div>
                    <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px"
                         style="padding-top: 10px; padding-left: 20px;">
                        <div>
                            <button matTooltip="Nova Meta" mat-mini-fab color="primary" (click)="addMeta()"
                                    style="width: 140px;border-radius: 5px;">
                                <mat-icon>add</mat-icon>
                                Meta
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="COLABORADORES">
            <div ngModelGroup="grupoColaboradorAcoesExecutadas" fxLayout="column" fxFlex="100%" style="margin: 2px 0;">
                <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <div *ngFor="let colaboradorAcao of acaoExecutada.colaboradores; let index = index">
                        <!-- <formulario-acoes-executadas-colaborador-turma [colaboradorAcao]="colaboradorAcao"
                                                                 [index]="index"
                                                                 [colaboradoresAcao]="acaoExecutada.colaboradores"
                                                                 [perfilAcesso]="perfilAcesso">
                        </formulario-acoes-executadas-colaborador-turma> -->
                    </div>
                    <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px"
                         style="padding-top: 10px; padding-left: 20px;">
                        <div>
                            <button matTooltip="Novo Colaborador" mat-mini-fab color="primary" (click)="addColaboradorAcao()"
                                    style="width: 140px;border-radius: 5px;">
                                <mat-icon>add</mat-icon>
                                Colaborador
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="PARTICIPANTES">
            <div ngModelGroup="grupoFrequenciaAcoesExecutadas" fxLayout="column" fxFlex="100%" style="margin: 2px 0;">
                <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <div *ngFor="let frequenciaAcao of acaoExecutada.frequencias; let index = index">
                        <!-- <formulario-acoes-executadas-frequencia-turma [frequenciaAcao]="frequenciaAcao"
                                                                [index]="index"
                                                                [frequenciasAcao]="acaoExecutada.frequencias"
                                                                [perfilAcesso]="perfilAcesso">
                        </formulario-acoes-executadas-frequencia-turma> -->
                    </div>
                    <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px"
                         style="padding-top: 10px; padding-left: 20px;">
                        <div>
                            <button matTooltip="Nova Frequencia" mat-mini-fab color="primary" (click)="addFrequenciaAcao()"
                                    style="width: 140px;border-radius: 5px;">
                                <mat-icon>add</mat-icon>
                                Participante
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</fieldset>